export default function genererTache(ordre) {
  return {
    libelle: null,
    description: null,
    ordre: ordre,
  };
}
